module.exports = __webpack_public_path__ + "static/img/img-fwtd.a07a1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-fwtd.png
// module id = 436
// module chunks = 2